import global from "global";

const savedItemsSdkProvider = () => global.asos.customer.savedItemsSdk;

export default savedItemsSdkProvider;
